/**
 * Policy-related constants and translations
 * Shared between RiskAssessmentReport and LinkedReportOverview components
 */

// Sub-score translations for detailed breakdown rows
export const SUB_SCORE_TRANSLATIONS = {
  effortRate: { en: "Effort rate", es: "Tasa de esfuerzo" },
  incomeConsistency: {
    en: "Income consistency",
    es: "Consistencia de ingresos",
  },
  incomeVerification: { en: "Income source", es: "Fuente de ingresos" },
  tenure: { en: "Employment tenure", es: "Antigüedad laboral" },
  employmentPredictability: {
    en: "Employment Type",
    es: "Tipo de empleo",
  },
  employerStability: {
    en: "Employer Category",
    es: "Categoría del empleador",
  },
  sectorCyclicality: {
    en: "Sector Cyclicality",
    es: "Ciclicidad del sector",
  },
  financialSkor: { en: "Financial Score", es: "Puntuación financiera" },
  defaultHistory: { en: "Default history", es: "Historial de impagos" },
  bankBehaviour: {
    en: "Bank Behaviour",
    es: "Comportamiento bancario",
  },
  rentPaymentBehaviour: {
    en: "Rent Payment Behaviour",
    es: "Comportamiento de pago de alquiler",
  },
  documentation: {
    en: "Document strength",
    es: "Solidez documental",
  },
};

// Mapping of policy requirements to their sub-scores (array format for RiskAssessmentReport)
export const POLICY_SUB_SCORE_MAP = {
  affordability: [
    {
      label: { en: "Effort rate", es: "Tasa de esfuerzo" },
      key: "effortRate",
    },
    {
      label: { en: "Income source", es: "Fuente de ingresos" },
      key: "incomeVerification",
    },
    {
      label: { en: "Income consistency", es: "Consistencia de ingresos" },
      key: "incomeConsistency",
    },
  ],
  "employment stability": [
    {
      label: { en: "Employment tenure", es: "Antigüedad laboral" },
      key: "tenure",
    },
    {
      label: { en: "Employment Type", es: "Tipo de empleo" },
      key: "employmentPredictability",
    },
    {
      label: { en: "Employer Category", es: "Categoría del empleador" },
      key: "employerStability",
    },
    {
      label: { en: "Sector Cyclicality", es: "Ciclicidad del sector" },
      key: "sectorCyclicality",
    },
  ],
  "financial behaviour": [
    {
      label: { en: "Financial Score", es: "Puntuación financiera" },
      key: "financialSkor",
    },
    {
      label: {
        en: "Rent Payment Behaviour",
        es: "Comportamiento de pago de alquiler",
      },
      key: "rentPaymentBehaviour",
    },
  ],
  "financial behavior": [
    {
      label: { en: "Financial Score", es: "Puntuación financiera" },
      key: "financialSkor",
    },
    {
      label: {
        en: "Rent Payment Behaviour",
        es: "Comportamiento de pago de alquiler",
      },
      key: "rentPaymentBehaviour",
    },
  ],
  "default risk": [
    {
      label: { en: "Default history", es: "Historial de impagos" },
      key: "defaultHistory",
    },
  ],
  documentation: [
    {
      label: { en: "Document strength", es: "Solidez documental" },
      key: "documentation",
    },
  ],
};

// Mapping of policy requirements to their sub-scores (array format for LinkedReportOverview)
export const PILLAR_SUB_SCORES = {
  affordability: [
    "effortRate",
    "incomeConsistency",
    "incomeVerification",
  ],
  "employment stability": [
    "tenure",
    "employmentPredictability",
    "employerStability",
    "sectorCyclicality",
  ],
  "financial behaviour": [
    "financialSkor",
    "rentPaymentBehaviour",
  ],
  "financial behavior": [
    "financialSkor",
    "rentPaymentBehaviour",
  ],
  "default risk": ["defaultHistory"],
  documentation: [],
};

// Helper to get badge variant from result text
export const getBadgeVariant = (result) => {
  const lowerResult = result?.toLowerCase() || "";
  // Handle both English and Spanish translations from API
  if (
    lowerResult === "strong" ||
    lowerResult === "fuerte" ||
    lowerResult === "acceptable" ||
    lowerResult === "aceptable"
  )
    return "success";
  if (lowerResult === "medium" || lowerResult === "media") return "warning";
  if (lowerResult === "weak" || lowerResult === "débil") return "danger";
  return "neutral";
};
